<script>
import moment from "moment";

export default {
  props: {
    currentPlanoConta: { type: Object },
  },
  data() {
    return {
      
    }
  },
  computed: {
    createdAt() {
      return moment(this.currentPlanoConta.created_at).format('DD/MM/YYYY HH:mm:ss')
    },
    updatedAt() {
      return moment(this.currentPlanoConta.updated_at).format('DD/MM/YYYY HH:mm:ss')
    }
  },
}
</script>

<template>
<div class="currentPlanoConta">
  <p>ID: {{ currentPlanoConta.id }}</p>
  <p>Código reduzido: {{ currentPlanoConta.codigo_reduzido }}</p>
  <p>Nome: {{ currentPlanoConta.descricao }}</p>
  <p>Natureza: {{ currentPlanoConta.natureza }}</p>
  <p>Grupo Pgto: {{ currentPlanoConta.grupo_pgto }}</p>
  <p>Conta Pgto: {{ currentPlanoConta.conta_pgto }}</p>
  <p>Classificação: {{ currentPlanoConta.classificacao }}</p>
  <p>Criado: <b-badge data-name="created_at" class="field-created_at" variant="secondary">{{ createdAt }}</b-badge></p>
  <p>Última alteração: <b-badge data-name="updated_at" class="field-updated_at" variant="secondary">{{ updatedAt }}</b-badge></p>
</div>
</template>